import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Link,
  Typography
} from '@mui/material'
import { Icon, Topbar, Page } from 'components'
import { theme } from 'config'
import { inject, observer } from 'mobx-react'
import React, { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { AuthStore, RoutingStore } from '../stores'
import { MainSidebar } from '../views'

export interface IFAQProps {
  authStore?: AuthStore
  routingStore?: RoutingStore
}

/**
 * @type all
 */


export const Faq = inject(
  'authStore',
  'routingStore'
)(
  observer((props: IFAQProps) => {
    const { t } = useTranslation()
    const [expanded, setExpanded] = React.useState<string | false>(false)
    const handleChange =
      (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false)
      }


    const FAQ: {
      chapter?:  string;
      key?:      number;
      accordionSummary?: Array<{
        question?: string;
        answer?:   string | ReactNode;
        panel?:    string;
      }>,
    }[] = [
      {
        key:     1,
        chapter: 'Generella frågor',
        accordionSummary: [
          {
            question: 'Kan jag gå en kurs från min mobil eller surfplatta?',
            answer:   'Ja, det går bra. Du kan även återuppta en kurs i mobilen/surfplattan som du påbörjat på datorn och vice versa.',
            panel:    'panel-1'
          },
          {
            question: 'Behöver jag slutföra hela utbildningen vid ett och samma tillfälle?',
            answer:   'Nej, du kan avbryta den när du vill och fortsätta senare. Varje steg du genomför sparas automatiskt.',
            panel:    'panel-2'
          },
          {
            question: 'Kan jag gå kurserna offline?',
            answer:   'Nej, du behöver vara ansluten till internet.',
            panel:    'panel-3'
          },
          {
            question: 'Erbjuder ni även andra utbildningar?',
            answer:   
            <Trans 
              t          = {t}
              components = {[<Link color={theme.palette.blue.main} href='https://www.bginstitute.se/utbildningar/bank-finans-forsakring/?utm_medium=referral&utm_source=lms&utm_campaign=aku&utm_content=kurs'/>]}
              i18nKey    = 'faq_other_courses_question_answer'/>,
              panel: 'panel-4'
          },
          {
            question: 'Hur får jag mitt intyg?',
            answer:   'Ditt intyg rapporteras in automatiskt till SwedSec.',
            panel:    'panel-5'
          },
          {
            question: 'När behöver ÅKU:n vara slutförd?',
            answer:   'Sista november är sista dagen såvida inte din arbetsgivare försett dig med ett annat slutdatum.',
            panel:    'panel-6'
          },
          {
            question: 'Kan jag hoppa direkt till det avslutande kunskapstestet?',
            answer:   'Ja, du kan gå direkt till kunskapstestet på din ÅKU.',
            panel:    'panel-7'
          },
          {
            question: 'Övriga frågor',
            answer:   
            <Trans
              t          = {t}
              components = {[<Link color={theme.palette.blue.main} sx={{cursor: 'pointer'}} onClick = {() => window.location.href = `mailto:support@bginstitute.se`}/>]}
              i18nKey    = 'faq_other_questions_answer'/>,
              panel: 'panel-8'
          }
        ],
      },
      /* {
        key:       2, 
        chapter: 'User settings',
        accordionSummary: [
          {
            question: 'How to change my email?',
            answer:   'Just pick a new email',
            panel:    'panel-3'
          },
          {
            question: 'How to update user name?',
            answer:   'Update user name',
            panel:    'panel-4'
          }
        ],
      }, */
    ]

    return (
      <Page sidebar={<MainSidebar />} topbar={<Topbar />}>
        <Container maxWidth='md'>
          <Typography marginBottom={5} textAlign='center' variant='h2'>
            {t('questions') + ' & ' + t('answers')}
          </Typography>

          {FAQ.map((i) => (
            <Container key={i.key}>
              <Typography mb={3} mt={3} variant='h4'>{i.chapter}</Typography>
              {i.accordionSummary.map((q) => 
              <Accordion
                key   = {q.question}
                style = {{borderRadius: 0, boxShadow: 'none', padding: '1rem', marginBottom: '1rem'}}
                expanded={expanded === q.panel}
                onChange={handleChange(q.panel)}
              >
              <AccordionSummary
                    expandIcon={<Icon size='size-18' iconId={expanded && expanded === q.panel ? 'remove' : 'add'} />}
                    aria-controls='panel1bh-content'
                    id='panel1bh-header'
                  >
                    <Typography variant='body1' fontWeight={theme.typography.fontWeightMedium}>{q.question}</Typography>
                  </AccordionSummary>
                    <AccordionDetails>
                      <Typography fontSize={theme.typography.fontSize}>
                        {q.answer}
                      </Typography>
                    </AccordionDetails>
              </Accordion>
            )}
            </Container>
          ))}
        </Container>
      </Page>
    )
  })
)

